import { Modal } from 'react-bootstrap';

const ImageViewerModal = ({ show, onClose, imageUrl, footer, location, alt = 'Zoomed' }) => {
  const caption = footer ?? location;

  return (
    <Modal
      show={show}
      onHide={onClose}
      size="xl"
      centered
      backdrop="static"
      keyboard
    >
      <Modal.Body
        onClick={onClose}
        className="p-0 d-flex align-items-center justify-content-center"
        style={{
          backgroundColor: '#000',
          height: '90vh',
          cursor: 'zoom-out',
        }}
      >
        <div className="position-relative w-100 h-100 d-flex align-items-center justify-content-center">
          <img
            src={imageUrl}
            alt={alt}
            style={{
              maxWidth: '100%',
              maxHeight: '100%',
              objectFit: 'contain',
            }}
          />

          {caption && (
            <div
              className="position-absolute bottom-0 start-0 end-0 text-white small px-3 py-2 text-truncate"
              style={{ background: 'rgba(0,0,0,0.6)' }}
              onClick={(e) => e.stopPropagation()} // don't close when clicking the footer
              title={typeof caption === 'string' ? caption : undefined}
            >
              {caption}
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ImageViewerModal;